module.exports = "/img/1.8255c6.webp";